import axios from "axios";
import InputGroup from "components/common/InputGroup";
import Icon from "components/Icons/Icon";
import { useState } from "react";

const BusinessSignup = ({ type, signupType = "businesssignup" }) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    if (name !== "" && email !== "" && company !== "") {
      axios
        .post(`/api/utils/subscribers/${signupType}`, { name, email, company, business_type: type })
        .then(() => {
          console.log("success");
          setSubmitted(true);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };
  return submitted ? (
    <div className="signup-success">
      <div className="icon-rounded">
        <Icon name="check" />
      </div>
      <h3>Thank you for signing up!</h3>
      <p>We'll be in touch soon.</p>
    </div>
  ) : (
    <>
      <h3>Let's start a partnership!</h3>

      <form onSubmit={onSubmit} className="creator-signup">
        <InputGroup
          id="creator-name"
          dataTestid="creator-name"
          label="Name"
          placeholder="Your name"
          //@ts-ignore
          onChange={(e) => setName(e.target.value)}
        />
        <InputGroup
          id="company-name"
          dataTestid="company-name"
          label="Company"
          placeholder="Company name"
          //@ts-ignore
          onChange={(e) => setCompany(e.target.value)}
        />
        <InputGroup
          id="company-email"
          dataTestid="company-email"
          label="Email"
          placeholder="Your email address"
          //@ts-ignore
          onChange={(e) => setEmail(e.target.value)}
        />

        <button type="submit" className="btn-rounded solid xl">
          Submit details
        </button>
        <p className="creator-signup__footnote">
          We use your details to follow up on your request. See our{" "}
          <a id="company-privacy-link" href="/privacy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
          .
        </p>
      </form>
    </>
  );
};

export default BusinessSignup;
